/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

import { closest } from '@/js/utils/css'
import { findOne } from '@/js/utils/dom'

/**
 * Reflect the chosen filename in the visible `.form-control` next to each
 * `.input-file`.
 *
 * @type {Listener}
 */
export default {
    selector: '.input-file',
    connect(element) {
        const onChange = () => {
            const formGroup = closest(element, '.form-group')
            const formControl = formGroup && findOne('.form-control', formGroup)
            if (!formControl) {
                return
            }

            const file = element.files[0]
            // Fall back to the title, then to the current label, so clearing the
            // input never blanks it (jQuery's .html(undefined) was a no-op).
            formControl.textContent = file?.name || formControl.getAttribute('title') || formControl.textContent
        }

        element.addEventListener('change', onChange)

        return () => element.removeEventListener('change', onChange)
    },
}
